import { css } from 'styled-system/css';

export const memberLoignStyles = {
	fontNormal: css({
		h: '12px',
		lineHeight: '12px',
		fontSize: '12px',
		fontWeight: '500'
	}),
	section: css({
		base: {
			justifyContent: 'start',
			md: {
				py: '84px',
			},
			'& .modalOverlay': {
				backdropFilter: 'none',
			}
		}
	}),
	modal: css({
		base: {
			w: '100%',
			maxW: '600px',
			borderRadius: '12px',
			zIndex: 'var(--modal-zindex)',
			overflow: 'hidden',
		}
	}),
	root: css({
		flex: '1 1 0',
		display: 'flex',
		flexDirection: 'column'
	}),
	header: css({
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '12px 12px 0 0',
		borderBottom: '1px solid {colors.jupiter.grey.40}',
		bgColor: 'jupiter.grey.20',
		position: 'relative',
		w: '100%',
		h: '48px',
		color: 'jupiter.grey.80',
		textAlign: 'center',
		px: '12px',
	}),
	iconArrow: css({
		base: {
			color: 'jupiter.grey.60',
			display: 'none',
			w: '20px',
			h: '20px',
		}
	}),
	iconClose: css({
		base: {
			display: 'block',
			position: 'absolute',
			right: '12px',
			top: '8px',
			cursor: 'pointer',
			'& .icon': {
				color: 'jupiter.grey.50',
				w: '30px',
				h: '30px',
			},
		}
	}),
	headerTitle: css({
		zIndex: 0,
		margin: '0',
		fontSize: '20px',
		fontWeight: '700',
	}),
	content: css({
		borderRadius: '0 0 12px 12px',
		w: '100%',
		bgColor: 'jupiter.grey.20',
		alignSelf: 'center',
		display: 'flex',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		overflowY: 'auto',
		flex: '1 1 0%',
		pb: '24px',
	}),
	formContainer: css({
		alignSelf: 'flex-start',
		display: 'flex',
		minW: '240px',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'flex-start',
		w: '100%',
		padding: '24px 24px 6px',
		gap: '18px',

		'& > form:last-of-type': {
			borderBottom: 'none', 
			paddingBottom: '0',
		},
	}),
	formSection: css({
		paddingBottom: '24px',
		borderBottom: '1px solid {colors.jupiter.grey.40}',
		display: 'flex',
		maxW: '100%',
		width: '544px',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '24px'
	}),
	inputGroup: css({
		display: 'flex',
		width: '100%',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		gap: '12px'
	}),
	secondGroup: css({
		display: 'flex',
		width: '100%',
		justifyContent: 'space-between',
		alignItems: 'center',
		p: '6px 2px',
	}),
	forgetPassword: css({
		cursor: 'pointer',
		userSelect: 'none',
		color: 'jupiter.main.primary',
	}),
	inputErrorText: css({
		color: 'jupiter.error.100',
		h: '15px',
		fontSize: '12px',
		fontWeight: '500',
		mt: '3px'
	}),
	reqErrorText: css({
		color: 'jupiter.error.100',
		minH: '39px',
		fontSize: '12px',
		fontWeight: '500',
		w: '100%',
		px: '3px',
	}),
	buttonContainer: css({
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		fontSize: '14px',
		color: 'jupiter.grey.10',
		fontWeight: 700,
		textAlign: 'center',
		lineHeight: 1,
		flexDirection: 'column',
		mt: '12px',
		gap: '12px'
	}),
	secondButton: css({
		bgColor: 'transparent',
		color: 'jupiter.main.primary',
		minH: '21px',
		fontSize: '14px',
		fontWeight: '700'
	}),
	loginButton: css({
		minH: '36px',
		w: '100%',
		mb: '3px',
	}),
	buttonText: css({
		alignSelf: 'stretch',
		margin: 'auto 0',
		padding: '0 6px',
	}),
	checkMessage: css({
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
		color: 'jupiter.grey.70',
		justifyContent: 'flex-start',
		fontWeight: 500,
		fontSize: '12px',
		cursor: 'pointer',
		userSelect: 'none',
	}),	
	checkIcon: css({
		aspectRatio: 1,
		objectFit: 'contain',
		objectPosition: 'center',
		w: '18px',
		h: '18px',
		color: 'jupiter.grey.60',
	}),
	checkActiveIcon: css({
		color: 'jupiter.main.primaryLight',
	}),
	messageContent: css({
		flex: 1,
		flexBasis: '0%',
		m: 0,
		color: 'jupiter.grey.70',
	}),
	loadingIcon: css({
		w: '24px',
		h: '24px',
	}),
};
  